import { bemCN } from "../../config/bem-classname";
import "./button.scss";

import { FC, ReactNode } from "react";

export enum ButtonSizes {
  small,
  big,
}

export enum ButtonColors {
  transition,
  green,
  violet,
  orange,
  red,
  blue,
  white,
  crimson,
  grey,
  pink,
}

type ButtonProps = {
  id?: string;
  text?: string;
  icon?: ReactNode;
  color: ButtonColors;
  size: ButtonSizes;
  noDisabled?: boolean;
  onClick?: () => void;
};

export const Button: FC<ButtonProps> = ({
  id,
  text,
  icon,
  color,
  size,
  noDisabled,
  onClick,
}) => {
  const buttonCN = bemCN("button");

  let sizeClass = ButtonSizes[size];
  let colorClass = ButtonColors[color];

  return (
    <button
      id={id}
      onClick={() => onClick && !noDisabled && onClick()}
      className={buttonCN({
        size: sizeClass,
        color: colorClass,
        disable: noDisabled,
      })}
    >
      {icon}
      {text}
    </button>
  );
};
